module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-300e91f90a465c91bc8ba0fb74795524.png";